import {
  Message
} from 'element-ui'
import axios from 'axios'
import {
  jsonToFormData
} from '@/utils/index'
import {
  getJwt
} from "@/utils/auth";
import router from '@/router/index'


//   axios.defaults.baseURL = 'http://47.107.234.15:18080/battery_admin';
//   axios.interceptors.request.use(function (config) {
//     let token = sessionStorage.getItem("token")
//     config.headers['access-token']=token
//     console.log(config)
//     return config;
//   }, function (error) {
//   return Promise.reject(error);
// });

axios.interceptors.request.use(
  (config) => {
    if (config.headers) {
      config.headers["platform"] = "IOT";
      config.headers["language"] = "en_US";
      config.headers["Authorization"] =
        "Bearer " + sessionStorage.getItem("login_jwt") || "";
    }
    return config;
  },
  (error) => {
    console.log(error);
    return Promise.reject();
  }
);


export function request(params, handleError = true) {

  return axios(params).then((res) => {

    //如果404之类的，可以统一处理
    return res.data
  }).then(res => {
    if (params.url.startsWith('http')) {
      return res
    }
    if (handleError == false) {

      return res;
    }
    // if (params.url.indexOf('/devices/subuser') == -1&&res && (!res.result && res.code != '2001001') && !res.url) {
    //   let text = res.message
    //   Message({
    //     message: text,
    //     type: 'warning',
    //     duration: 5000
    //   })
    //   return null
    // }
    return res
  }).catch((error, e, c) => {
    console.log(error,'error');
    if (error.response && error.response.data) {
      let res = error.response.data;
      if (res && handleError == false) {
        return res;
      }
      console.log(res,'code');
      if (res && !res.result) {
        let text = res.message
        if (text == 'UC :password error' || text == "UC :not exist user") {
          text = 'login name or password error！'
        }
        if (text == 'Bad Request' && router.app._route.path == '/login') {
          text = 'account or password is invalid！'
        }
        if (text == 'Unauthorized') {
          text = 'content does not exist！'
        }
        if (text == '当前用户无权限') {
          text = 'The current user has no permission'
        }
        Message({
          message: text,
          type: 'warning',
          duration: 5000
        })
        return null
      }
    }
    console.log(error)
  })
}

export function get(url, params = {}) {
  // params['jwt'] = getJwt()
  let hasParams = Object.keys(params).length > 0;
  return request({
    url: url,
    method: 'get',
    params
  })
}
export function get2(url, params = {}) {
  params['jwt'] = getJwt()
  return request({
    url: url,
    method: 'get',
    params
  }, false)
}

export function deleteRequest(url, params = {}) {
  params['jwt'] = getJwt()
  return request({
    url: url + (params != undefined ? '?' + jsonToFormData(params) : ''),
    method: 'delete',
  })
}

export function deleteBodyRequest(url, params = {}) {
  return request({
    url: url,
    method: 'delete',
    data: params
  })
}



export function postForm(url, params) {
  let queryParams = {};
  queryParams['jwt'] = getJwt()
  return request({
    url: url + '?' + jsonToFormData(params),
    method: 'POST',
    data: Array.isArray(params) ? params : jsonToFormData(params),
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8'
    }
  })

}

//下载文件
function download(data, fileName) {
  if (!data) {
    return
  }
  let blob = new Blob([data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
  })
  let url = window.URL.createObjectURL(blob);
  let aLink = document.createElement("a");
  aLink.style.display = "none";
  aLink.href = url;
  aLink.setAttribute("download", fileName);
  document.body.appendChild(aLink);
  aLink.click();
  document.body.removeChild(aLink); //下载完成移除元素
  window.URL.revokeObjectURL(url); //释放掉blob对象
}


export function getExcel(url, params) {
  axios.get(url, {
    params: params,
    responseType: 'blob', //二进制流
  }).then(function(res) {
    if (res.headers['content-type'] === 'application/json;charset=UTF-8') {
      console.log(res.data)

      let reader = new FileReader();
      reader.onload = function(event) {
        let res = JSON.parse(reader.result);

        if (res && res.code != 0 && res.code != 2001001) {
          let text = res.data
          if (text == null) {
            text = res.message
            if (text == null) {
              text = '服务器繁忙！'
            }
          }
          if (text == 'UC :password error' || text == "UC :not exist user") {
            text = 'login name or password error！'
          }
          Message({
            message: text,
            type: 'warning',
            duration: 5000
          })
          return null
        }
      };
      reader.readAsText(res.data);
      return;


    }
    let fileName = res.headers['content-disposition'];
    if (!fileName) {
      fileName = "excel";
    } else {
      fileName = fileName.substring("attachment;filename* = UTF-8''".length, fileName.length)
    }
    download(res.data, decodeURIComponent(fileName))
  }).catch(function(error) {
    console.log(error)
  });


  // window.location.href=axios.defaults.baseURL+"/"+url + (params ? '?' + jsonToFormData(params):"");

}

export function postFormData(url, params, handleError = true) {
  let requestBody = new FormData()
  Object.keys(params).forEach((item, i) => {
    if (params[item] === undefined || params[item] === null || params[item] === '') {
      return
    }
    requestBody.append(item, params[item])
  })
  let queryParams = {};
  queryParams['jwt'] = getJwt()
  return request({
    url: url + "?" + jsonToFormData(queryParams),
    method: 'POST',
    data: requestBody,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  }, handleError)
}

export function postJSON(url, params) {
  let requestBody = {};
  if (!Array.isArray(params)) {
    Object.keys(params).forEach((item, i) => {
      if (params[item] === undefined || params[item] === null || params[item] === '') { //过来undefine
        return
      }
      requestBody[item] = params[item]
    })
  } else {
    requestBody = params
  }

  if (url.indexOf("?") != -1) {
    url = url + "&jwt=" + getJwt();
  } else {
    url = url + "?jwt=" + getJwt();
  }
  return request({
    url: url,
    method: 'POST',
    data: requestBody,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }

  })
}

export function putJSON(url, params, handleError = true) {
  let requestBody = {}
  if (!Array.isArray(params)) {
    Object.keys(params).forEach((item, i) => {
      if (params[item] === undefined || params[item] === null || params[item] === '') { //过来undefine
        return
      }
      requestBody[item] = params[item]
    })
  } else {
    requestBody = params
  }
  if (url.indexOf("?") != -1) {
    url = url + "&jwt=" + getJwt();
  } else {
    url = url + "?jwt=" + getJwt();
  }

  return request({
    url: url,
    method: 'put',
    data: requestBody,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }

  }, handleError)
}

export function patchJSON(url, params, handleError = true) {
  let requestBody = {}
  if (!Array.isArray(params)) {
    Object.keys(params).forEach((item, i) => {
      if (params[item] === undefined || params[item] === null || params[item] === '') { //过来undefine
        return
      }
      requestBody[item] = params[item]
    })
  } else {
    requestBody = params
  }

  return request({
    url: url,
    method: 'PATCH',
    data: requestBody,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }

  }, handleError)
}

export function putJSO(url, params, handleError = true) {
  let requestBody = {}
  if (!Array.isArray(params)) {
    Object.keys(params).forEach((item, i) => {
      if (params[item] === undefined || params[item] === null || params[item] === '') { //过来undefine
        return
      }
      requestBody[item] = params[item]
    })
  } else {
    requestBody = params
  }
  // if(url.indexOf("?")!=-1){
  //   url=url+"&jwt="+getJwt();
  // }else{
  //   url=url+"?jwt="+getJwt();
  // }

  return request({
    url: url,
    method: 'put',
    data: requestBody,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }

  })
}
